module.exports = __webpack_public_path__ + "img/policyExplain.722de7f7.jpg";